import { render, staticRenderFns } from "./TbSkuInfoCard.vue?vue&type=template&id=a225886c&scoped=true&"
import script from "./TbSkuInfoCard.vue?vue&type=script&lang=js&"
export * from "./TbSkuInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./TbSkuInfoCard.vue?vue&type=style&index=0&id=a225886c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a225886c",
  null
  
)

export default component.exports